import { useState, useEffect } from 'react';
import { collection, query, orderBy, onSnapshot } from 'firebase/firestore';
import { CoreFirebaseService } from '@modules/firebase-core/services/CoreFirebaseService';
import type { MinimalTask } from '../types';

/**
 * Hook to subscribe to project tasks in real-time.
 * Used by Reviews, BigNumbers, and StudyCases tables for task association.
 */
export function useTasks(projectId: string) {
  const [tasks, setTasks] = useState<MinimalTask[]>([]);

  useEffect(() => {
    if (!projectId) return;

    const firestore = CoreFirebaseService.getInstance().firestore;
    const tasksRef = collection(firestore, 'projects', projectId, 'tasks');
    const q = query(tasksRef, orderBy('createdAt', 'desc'));

    const unsub = onSnapshot(q, (snap) => {
      setTasks(snap.docs.map(d => {
        const data = d.data();
        return { id: d.id, name: data.name || '', description: data.description || '' };
      }));
    }, (err) => {
      console.error('Error listening to tasks:', err);
    });

    return () => unsub();
  }, [projectId]);

  return tasks;
}
